import _ from "lodash"
import { diff } from '../lib/render-object'
import { ChangeProps } from './change-renderer'

const mapper = (text) => {
  return {
    folderpath: 'Folder Path',
  }[text] || _.startCase(text)
}

const resource_m = (text) => {
  return {
  }[text] || _.startCase(text)
}

type EventChange = {
  new: object
  old: object
}

const alwaysDrop = ['externalreference', 'organizationid']

export const diffif = (props: ChangeProps) => {
  if (props.resource !== 'folder' || props.method !== 'PATCH') return null
  return () => {
    const change = JSON.parse(props.change) as EventChange
    return {
      atRest: 'Edit Folder',
      diffs: diff(change.new, change.old, mapper, null, alwaysDrop),
      ...props
    }
  }
}
